import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { useAgGridTableContext } from 'core/states';
import { UpdateJobName } from 'jobs/components/UpdateJobName';
import { Variant } from 'theme/enums';

export const UpdateJobNameButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const { deselectAllRows, gridApi, selectedRows } = useAgGridTableContext();

  const defaultValues = useMemo(() => {
    return {
      jobName: selectedRows?.[0]?.name,
    };
  }, [selectedRows]);

  const jobId = useMemo(() => selectedRows?.[0]?.id, [selectedRows]);
  const projectId = useMemo(() => selectedRows?.[0]?.projectId, [selectedRows]);

  const isDisabled = useMemo(
    () => !(selectedRows.length === 1 && selectedRows[0]?.access?.editAsCreatorAllowed),
    [selectedRows]
  );

  const onSubmitSuccess = () => {
    deselectAllRows();
    gridApi?.refreshServerSide();
  };

  return (
    <>
      <Button
        text={t('buttonLabelEditJobName')}
        variant={Variant.OUTLINED}
        onClick={() => setIsOpen(true)}
        disabled={isDisabled}
      />

      <UpdateJobName
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        jobId={jobId}
        projectId={projectId}
        onSubmitSuccess={onSubmitSuccess}
        defaultValues={defaultValues}
      />
    </>
  );
};
